import { app } from '../../config/Firebase';

const clientesDB = app.firestore().collection('Clientes');

export const addNewClient = (data) => clientesDB.add(data);


export const getAllClients = () => clientesDB.get();

export const deleteClient = (id) => clientesDB.doc(id).delete();